module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Verbindung 1.08307a56.svg";